(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["db-contact-photo-mail"] && !Shopify.designMode) return;
  try {
    document.addEventListener('toggle', (event) => {
    const disclosure = event.target;
    if (!(disclosure instanceof HTMLDetailsElement) || !disclosure.matches('[data-photo-mail-address]') || !disclosure.open) return;
    const result = disclosure.querySelector('.db-photo-mail__result');
    const link = disclosure.querySelector('[data-photo-mail-link]');
    if (!result || !link || link.hasAttribute('href')) return;
    try {
      const bytes = Uint8Array.from(atob(disclosure.dataset.photoMailAddress), (character) => character.charCodeAt(0));
      const address = new TextDecoder().decode(bytes).trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(address)) return;
      link.textContent = address;
      link.href = 'mailto:' + encodeURIComponent(address) + '?subject=' + encodeURIComponent(disclosure.dataset.photoMailSubject || '');
      result.hidden = false;
    } catch {
      result.textContent = 'Gebruik het contactformulier om ons te bereiken.';
      result.hidden = false;
    }
  }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["db-kw-bundle-entry"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kw-bundle-entry')) {
    customElements.define('kw-bundle-entry', class extends HTMLElement {
      connectedCallback() {
        this.link = this.querySelector('a');
        this.onReady = () => { this.hidden = !document.getElementById(this.dataset.target); };
        this.onClick = () => {
          const target = document.getElementById(this.dataset.target);
          if (target) requestAnimationFrame(() => target.querySelector('select[data-article]')?.focus({ preventScroll: true }));
        };
        this.link.addEventListener('click', this.onClick);
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.onReady, { once: true });
        else this.onReady();
      }
      disconnectedCallback() {
        this.link?.removeEventListener('click', this.onClick);
        document.removeEventListener('DOMContentLoaded', this.onReady);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["db-kw-bundle"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kw-lance-bundle')) {
    customElements.define('kw-lance-bundle', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.catalog = JSON.parse(this.querySelector('[data-catalog]').textContent);
        this.form = this.querySelector('form');
        this.select = this.querySelector('select[data-variant]');
        this.articleSelect = this.querySelector('select[data-article]');
        this.placeholder = this.select.options[0].textContent;
        this.buy = this.querySelector('[data-buy]');
        this.choiceImage = this.querySelector('.kw-bundle__choice-image');
        this.choiceLink = this.querySelector('[data-part-link]');
        this.choicePlaceholder = this.querySelector('[data-choice-placeholder]');
        this.choiceName = this.querySelector('[data-choice-name]');
        this.summary = this.querySelector('[data-selection-summary]');
        this.money = new Intl.NumberFormat(document.documentElement.lang || 'nl-BE', {style: 'currency', currency: this.dataset.currency || 'EUR'});
        this.cache = new Map();
        this.version = 0;
        if (this.articleSelect) this.articleSelect.addEventListener('change', () => this.selectArticle());
        this.select.addEventListener('change', () => this.updatePrice());
        this.form.addEventListener('submit', event => this.addBundle(event));
        this.selectArticle();
      }
      async selectArticle() {
        const version = ++this.version;
        const handle = this.dataset.fixedProduct || this.articleSelect?.value;
        const item = this.catalog.find(item => item.handle === handle);
        this.currentItem = item || null;
        this.select.replaceChildren(new Option(this.placeholder, ''));
        this.select.disabled = true;
        this.buy.disabled = true;
        this.querySelector('[data-error]').hidden = true;
        this.updatePrice();
        if (!item) {
          if (this.choiceLink) this.choiceLink.hidden = true;
          if (this.choicePlaceholder) this.choicePlaceholder.hidden = false;
          if (this.choiceName) this.choiceName.textContent = this.dataset.choiceName;
          return;
        }
        this.querySelector('[data-fit-note]').textContent = item.note;
        this.querySelector('[data-option-label]').textContent = `${this.articleSelect ? '2. ' : ''}${item.label}`;
        if (item.image && this.choiceImage) {
          this.choiceImage.removeAttribute('srcset');
          this.choiceImage.src = item.image.url;
          this.choiceImage.alt = item.image.altText || item.title;
          this.choiceLink.href = `${this.dataset.root}products/${item.handle}`;
          this.choiceLink.hidden = false;
          this.choicePlaceholder.hidden = true;
          this.choiceName.textContent = item.title;
        }
        try {
          if (!this.cache.has(item.bundleHandle)) {
            this.cache.set(item.bundleHandle, fetch(`${this.dataset.root}products/${item.bundleHandle}.js`).then(async response => {
              if (!response.ok) throw new Error('De bundel is momenteel niet beschikbaar. Neem contact met ons op.');
              return response.json();
            }).catch(error => { this.cache.delete(item.bundleHandle); throw error; }));
          }
          const bundle = await this.cache.get(item.bundleHandle);
          if (version !== this.version) return;
          for (const variant of bundle.variants.filter(variant => variant.option1 === item.model)) {
            const text = variant.option2 === 'Default Title' ? 'Standaard' : variant.option2;
            const option = new Option(`${text}${variant.available ? '' : ' — Niet beschikbaar'}`, variant.id);
            option.disabled = !variant.available;
            option.dataset.price = variant.price;
            option.dataset.compare = variant.compare_at_price;
            option.dataset.nozzleValue = text;
            this.select.add(option);
          }
          this.select.disabled = this.select.options.length < 2;
          if (this.select.options.length === 2 && !this.select.options[1].disabled) this.select.selectedIndex = 1;
          this.updatePrice();
        } catch (failure) {
          if (version !== this.version) return;
          const error = this.querySelector('[data-error]');
          error.textContent = failure.message;
          error.hidden = false;
        }
      }
      updatePrice() {
        const option = this.select.selectedOptions[0];
        const price = Number(option?.dataset.price || 0);
        const compare = Number(option?.dataset.compare || 0);
        const values = {price, compare, saving: compare - price};
        for (const [key, value] of Object.entries(values)) this.querySelector(`.kw-bundle__price [data-${key}]`).textContent = this.select.value ? this.money.format(value / 100) : '—';
        this.buy.disabled = !this.select.value || option?.disabled;
        if (this.summary) {
          this.summary.textContent = this.currentItem
            ? `1× ST-2300 + 1× ${this.currentItem.title}${this.select.value ? ` · ${option.textContent}` : ''}`
            : this.dataset.summaryDefault;
        }
      }
      async addBundle(event) {
        event.preventDefault();
        if (!this.form.reportValidity() || this.buy.disabled) return;
        this.buy.disabled = true;
        const error = this.querySelector('[data-error]');
        error.hidden = true;
        try {
          const response = await fetch(this.dataset.addUrl, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(this.select.value),quantity:1}]})});
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || result.message || 'Toevoegen is niet gelukt. Probeer opnieuw.');
          window.location.assign(this.dataset.cartUrl);
        } catch (failure) {
          error.textContent = failure.message;
          error.hidden = false;
          this.updatePrice();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["db-nozzle-calculator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('db-nozzle-calculator')) {
    customElements.define('db-nozzle-calculator', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        if (document.readyState === 'loading' && !this.querySelector('[data-nozzle-dialog]')) {
          document.addEventListener('DOMContentLoaded', () => this.isConnected && this.initialize(), { once: true });
        } else this.initialize();
      }
      initialize() {
        if (this.ready) return;
        this.dialog = this.querySelector('[data-nozzle-dialog]');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.ready = true;
        this.trigger = this.querySelector('[data-nozzle-trigger]');
        this.form = this.querySelector('[data-nozzle-form]');
        this.error = this.querySelector('[data-nozzle-error]');
        this.results = this.querySelector('[data-nozzle-results]');
        this.summary = this.querySelector('[data-nozzle-result]');
        this.cards = this.querySelector('[data-nozzle-cards]');
        this.selection = this.querySelector('[data-nozzle-selection]');
        this.pressure = this.querySelector('[data-nozzle-pressure]');
        this.flow = this.querySelector('[data-nozzle-flow]');
        this.unit = this.querySelector('[data-nozzle-unit]');
        this.count = this.querySelector('[data-nozzle-count]');
        this.messages = JSON.parse(this.querySelector('[data-nozzle-messages]').textContent);
        this.family = JSON.parse(this.querySelector('[data-nozzle-family]')?.textContent || '[]');
        const pending = this.constructor.pendingSelection;
        if (pending && pending.productId === this.dataset.productId) {
          this.pressure.value = pending.pressure; this.flow.value = pending.flow; this.unit.value = pending.unit; this.count.value = pending.count;
          this.selection.textContent = this.text('selected',{ code: pending.code, value: pending.sku });
          this.constructor.pendingSelection = null;
        }
        this.events = new AbortController();
        const settings = { signal: this.events.signal };
        this.trigger.addEventListener('click', () => this.open(), settings);
        this.querySelector('[data-nozzle-close]').addEventListener('click', () => this.dialog.close(), settings);
        this.form.addEventListener('submit', event => { event.preventDefault(); event.stopPropagation(); this.calculate(true); }, settings);
        for (const type of ['input','change']) this.form.addEventListener(type, event => { event.stopPropagation(); this.reset(); }, settings);
        this.dialog.addEventListener('close', () => { this.trigger.setAttribute('aria-expanded','false'); this.unlock(); if (this.trigger.isConnected && !this.trigger.hidden) this.trigger.focus({ preventScroll: true }); }, settings);
        this.dialog.addEventListener('click', event => { const rect = this.dialog.getBoundingClientRect(); if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dialog.close(); }, settings);
        const target = this.dataset.targetSelect && document.getElementById(this.dataset.targetSelect);
        if (target) {
          target.insertAdjacentElement('afterend', this.trigger);
          this.movedTrigger = true;
          this.observer = new MutationObserver(() => this.refresh());
          this.observer.observe(target, { childList: true, attributes: true, attributeFilter: ['disabled'], subtree: true });
        }
        this.refresh();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        if (this.dialog?.open) this.dialog.close();
        this.events?.abort();
        if (this.movedTrigger && this.trigger) this.prepend(this.trigger);
        this.movedTrigger = false;
        this.unlock();
        this.ready = false;
      }
      unlock() { if (!document.querySelector('.db-nozzle-dialog[open]')) document.documentElement.classList.remove('db-nozzle-dialog-open'); }
      text(key, values = {}) { let value = this.messages[key] || ''; for (const [name, replacement] of Object.entries(values)) value = value.replaceAll(`[${name}]`, String(replacement)); return value; }
      number(value, digits = 2) { return new Intl.NumberFormat(document.documentElement.lang || 'nl', { maximumFractionDigits: digits }).format(value); }
      sizeCode(size) { const scaled = size * 10; return Math.abs(scaled - Math.round(scaled)) < 1e-8 ? String(Math.round(scaled)).padStart(3,'0') : this.number(size,3); }
      parseSize(raw) {
        const value = String(raw || '').trim().replace(/^(?:nozzle|maat|size)\s*/i,'').replace(/^[DM](?=\d)/i,'');
        if (/^\d+[.,]\d+$/.test(value)) { const size = Number(value.replace(',','.')); return size > 0 && Number.isFinite(size) ? { size, angle: null } : null; }
        if (!/^\d{1,6}$/.test(value)) return null;
        let code = value, angle = null;
        if (value.length >= 4) {
          const prefix = Number(value.slice(0,2));
          if (![0,15,20,25,40,65,80,90].includes(prefix)) return null;
          angle = prefix;
          code = value.slice(2);
        }
        const size = code.length >= 3 ? Number(code) / 10 : Number(code);
        return size > 0 && Number.isFinite(size) ? { size, angle } : null;
      }
      controls() {
        if (this.dataset.targetSelect) {
          const select = document.getElementById(this.dataset.targetSelect);
          return select && !select.disabled ? Array.from(select.options).filter(option => option.value) : [];
        }
        const picker = document.getElementById(this.dataset.pickerId);
        const group = picker?.querySelectorAll('fieldset, .product-form__input--dropdown')[Number(this.dataset.optionPosition) - 1];
        const select = group?.querySelector('select');
        return select ? Array.from(select.options) : Array.from(group?.querySelectorAll('input[type="radio"]') || []);
      }
      choices() {
        if (this.dataset.mode === 'family') return this.family.map(item => ({ ...item, source: 'family', angle: null })).sort((a,b) => a.size - b.size);
        if (this.dataset.mode === 'generic') return ['010','015','020','025','030','035','040','045','050','055','060','065','070','075','080','085','090','10','11','12','125','15','175','20'].map(raw => ({ ...this.parseSize(raw), raw, value: raw, available: true, source: 'generic' }));
        const controls = this.controls();
        const current = controls.find(control => control.selected || control.checked);
        const currentSize = this.parseSize(current?.dataset.nozzleValue || current?.value);
        const values = controls.map(control => {
          const raw = control.dataset.nozzleValue || control.value;
          const parsed = this.parseSize(raw);
          if (!parsed) return null;
          return { ...parsed, raw, value: control.value, control, available: !control.disabled && control.dataset.nozzleAvailable !== 'false' && !control.classList.contains('disabled') };
        }).filter(Boolean).filter(choice => currentSize?.angle == null || choice.angle == null || choice.angle === currentSize.angle);
        const distinct = new Map();
        for (const choice of values) { const previous = distinct.get(choice.size); if (!previous || (!previous.available && choice.available) || choice.control === current) distinct.set(choice.size, choice); }
        return Array.from(distinct.values()).sort((a,b) => a.size - b.size);
      }
      refresh() {
        const hidden = this.choices().length === 0;
        this.hidden = hidden;
        this.trigger.hidden = hidden;
        if (hidden && this.dialog.open) this.dialog.close();
      }
      open() {
        this.refresh();
        if (this.hidden || this.dialog.open) return;
        this.reset();
        this.trigger.setAttribute('aria-expanded','true');
        document.documentElement.classList.add('db-nozzle-dialog-open');
        this.dialog.showModal();
        if (this.pressure.value && this.flow.value) this.calculate(false);
        this.pressure.focus({ preventScroll: true });
      }
      reset() {
        this.error.hidden = true;
        this.error.textContent = '';
        this.results.hidden = true;
        this.cards.replaceChildren();
        for (const input of [this.pressure,this.flow,this.count]) input.removeAttribute('aria-invalid');
      }
      decimal(input) { const value = input.value.trim(); return /^(?:\d+(?:[.,]\d+)?|[.,]\d+)$/.test(value) ? Number(value.replace(',','.')) : NaN; }
      fail(key, input) { this.error.textContent = this.text(key); this.error.hidden = false; if (input) { input.setAttribute('aria-invalid','true'); input.focus({ preventScroll: true }); } }
      calculate(moveFocus) {
        this.reset();
        const pressure = this.decimal(this.pressure), flowInput = this.decimal(this.flow), count = Number(this.count.value);
        if (!(pressure > 0) || !Number.isFinite(pressure)) return this.fail('invalid_pressure',this.pressure);
        if (!(flowInput > 0) || !Number.isFinite(flowInput)) return this.fail('invalid_flow',this.flow);
        if (!Number.isInteger(count) || count < 1 || count > 4) return this.fail('invalid_count',this.count);
        const info = this.closest('product-info');
        if (info?.pendingRequestUrl) return this.fail('loading');
        const flow = (this.unit.value === 'l/h' ? flowInput / 60 : flowInput) / count;
        const target = 4.472 * flow / Math.sqrt(pressure);
        const pool = this.choices();
        if (!Number.isFinite(target) || target <= 0 || !pool.length) return this.fail('no_choices');
        const tolerance = 0.0005;
        const exact = pool.find(choice => Math.abs(choice.size - target) <= tolerance);
        const lower = pool.filter(choice => choice.size < target - tolerance).at(-1);
        const upper = pool.find(choice => choice.size > target + tolerance);
        this.summary.textContent = this.text('result_summary', { size: this.number(target,3), flow: this.number(flow,2), pressure: this.number(pressure,2) });
        if (exact) this.addCard(exact,'exact',flow);
        else { this.addCard(lower,'lower',flow); this.addCard(upper,'upper',flow); }
        this.results.hidden = false;
        if (moveFocus) { this.summary.focus({ preventScroll: true }); this.summary.scrollIntoView({ block: 'nearest', behavior: 'auto' }); }
      }
      addCard(choice, direction, flow) {
        const card = document.createElement('article'); card.className = 'db-nozzle__card';
        const tag = document.createElement('p'); tag.className = 'db-nozzle__tag'; tag.textContent = this.text(direction); card.append(tag);
        if (!choice) { card.classList.add('db-nozzle__card--empty'); const empty = document.createElement('p'); empty.className = 'db-nozzle__detail'; empty.textContent = this.text(direction === 'lower' ? 'no_lower' : 'no_upper'); card.append(empty); this.cards.append(card); return; }
        const code = this.sizeCode(choice.size);
        const size = document.createElement('h4'); size.className = 'db-nozzle__size'; size.textContent = this.text('size_label',{ code }); card.append(size);
        const raw = document.createElement('p'); raw.className = 'db-nozzle__detail'; raw.textContent = this.text('product_choice',{ value: choice.raw }); card.append(raw);
        if (choice.source === 'family') {
          raw.textContent = choice.title;
          const sku = document.createElement('p'); sku.className = 'db-nozzle__detail'; sku.textContent = this.text('family_sku',{ sku: choice.raw }); card.append(sku);
          const price = document.createElement('p'); price.className = 'db-nozzle__detail'; price.textContent = this.text('family_price',{ price: choice.price }); card.append(price);
        } else if (choice.source === 'generic') raw.textContent = this.text('generic_result_note');
        const expectedPressure = (4.472 * flow / choice.size) ** 2;
        const estimate = document.createElement('p'); estimate.className = 'db-nozzle__detail'; estimate.textContent = this.text('pressure_estimate',{ pressure: this.number(expectedPressure,1) }); card.append(estimate);
        const note = document.createElement('p'); note.className = 'db-nozzle__effect'; note.textContent = this.text(`${direction}_note`); card.append(note);
        const button = document.createElement('button'); button.className = 'db-nozzle__choose'; button.type = 'button'; button.disabled = !choice.available; button.textContent = this.text(choice.available ? (choice.source === 'generic' ? 'remember' : 'choose') : 'unavailable');
        button.addEventListener('click', () => this.apply(choice.value,code)); card.append(button); this.cards.append(card);
      }
      apply(value, code) {
        const choice = this.choices().find(item => item.value === value);
        if (!choice?.available) return this.fail('selection_error');
        if (choice.source === 'generic') { this.selection.textContent = this.text('remembered',{ code }); this.dialog.close(); return; }
        if (choice.source === 'family') {
          if (choice.productId === this.dataset.productId) { this.selection.textContent = this.text('selected',{ code, value: choice.raw }); this.dialog.close(); return; }
          return this.switchProduct(choice,code);
        }
        const control = choice.control;
        const target = control.tagName === 'OPTION' ? control.parentElement : control;
        if (control.tagName === 'OPTION') target.value = value; else control.checked = true;
        this.selection.textContent = this.text('selected',{ code, value: choice.raw });
        this.dialog.close();
        target.dispatchEvent(new Event('change',{ bubbles: true }));
      }
      async switchProduct(choice,code) {
        const info = this.closest('product-info');
        const url = new URL(choice.url,location.origin);
        const originalUrl = location.href;
        const originalTitle = document.title;
        if (!info || url.origin !== location.origin || !url.pathname.includes('/products/')) return this.fail('family_error');
        this.error.hidden = false; this.error.textContent = this.text('family_switching');
        this.cards.querySelectorAll('button').forEach(button => button.disabled = true);
        try {
          const response = await fetch(`${url.pathname}?variant=${encodeURIComponent(choice.value)}`,{headers:{Accept:'text/html'}});
          if (!response.ok) throw new Error('Product unavailable');
          const html = new DOMParser().parseFromString(await response.text(),'text/html');
          const nextInfo = html.querySelector("product-info[id^='MainProduct']");
          const nextVariant = nextInfo?.querySelector('form[action*="/cart/add"] input[name="id"]');
          if (!nextInfo || !html.querySelector('main') || nextVariant?.value !== choice.value) throw new Error('Variant mismatch');
          if (!html.head.querySelector('title')) {
            const title = html.querySelector('title');
            const normalizedTitle = html.createElement('title');
            normalizedTitle.textContent = title?.textContent || nextInfo.querySelector('h1')?.textContent || choice.title;
            html.head.append(normalizedTitle);
          }
          this.constructor.pendingSelection = { productId: choice.productId, code, sku: choice.raw, pressure: this.pressure.value, flow: this.flow.value, unit: this.unit.value, count: this.count.value };
          this.dialog.close();
          info.handleSwapProduct(`${url.pathname}?variant=${encodeURIComponent(choice.value)}`,true)(html);
          const canonical = html.querySelector('link[rel="canonical"]'); if (canonical) document.querySelector('link[rel="canonical"]')?.setAttribute('href',canonical.href);
        } catch {
          this.constructor.pendingSelection = null;
          if (document.querySelector("product-info[id^='MainProduct']") === info) { history.replaceState({},'',originalUrl); document.title = originalTitle; }
          this.fail('family_error');
          this.calculate(false);
          this.fail('family_error');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["db-st2300-bundle-summary"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('db-kw-set-summary')) {
    class DbKwSetSummary extends HTMLElement {
      connectedCallback() {
        this.initialize = () => {
          if (this.unsubscribe || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            if (data.sectionId !== this.dataset.section) return;
            const fresh = data.html.querySelector(`db-kw-set-summary[data-section="${this.dataset.section}"]`);
            if (!fresh) return;
            this.dataset.variant = fresh.dataset.variant;
            this.innerHTML = fresh.innerHTML;
          });
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.initialize, { once: true });
        else this.initialize();
      }
      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.initialize);
        this.unsubscribe?.();
        this.unsubscribe = null;
      }
    }
    customElements.define('db-kw-set-summary', DbKwSetSummary);
  }
  } catch(e) { console.error(e); }
})();

})();
